import { zIndexContextMenu } from 'crazyEditor/core/globals';

export default {
  wrapper: {
    zIndex: zIndexContextMenu
  },
};
